import { Link } from 'react-router-dom'
import './Hero.css'

export default function Hero() {
  return (
    <section className="hero" aria-label="Welcome to Jesse B Tattoos">
      <div className="hero__bg" aria-hidden="true">
        <div className="hero__bg-grid" />
        <div className="hero__bg-blob hero__bg-blob--1" />
        <div className="hero__bg-blob hero__bg-blob--2" />
      </div>

      <div className="hero__inner container">
        <div className="hero__content">
          <span className="hero__eyebrow" aria-hidden="true">✦ Custom Tattoo Art ✦</span>

          <h1 className="hero__title">
            <span className="hero__title-line1">Ink That</span>
            <span className="hero__title-line2">Tells Your</span>
            <span className="hero__title-line3">Story</span>
          </h1>

          <p className="hero__sub">
            Bold, expressive, and completely yours. Jesse B Tattoos brings
            custom art to life with a traditional flair.
          </p>

          <div className="hero__ctas">
            <Link to="/book" className="hero__cta hero__cta--primary">
              Book a Session
            </Link>
            <Link to="/portfolio" className="hero__cta hero__cta--secondary">
              View Portfolio
            </Link>
          </div>

          <div className="hero__stats" aria-label="Quick facts">
            <div className="hero__stat">
              <span className="hero__stat-num">500+</span>
              <span className="hero__stat-label">Tattoos Done</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <span className="hero__stat-num">5★</span>
              <span className="hero__stat-label">Rated Artist</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <span className="hero__stat-num">5+</span>
              <span className="hero__stat-label">Years Experience</span>
            </div>
          </div>
        </div>

        {/* Hero image */}
        <div className="hero__visual" aria-hidden="true">
          <div className="hero__image-frame">
            <img
              src="/images/hero.webp"
              alt="Jesse B tattooing a client"
              width="600"
              height="700"
              loading="eager"
              fetchpriority="high"
              className="hero__image"
            />
          </div>

          <div className="hero__visual-badge">
            <span className="hero__badge-text">Est.</span>
            <span className="hero__badge-year">2021</span>
          </div>

          <span className="hero__deco hero__deco--star1">✦</span>
          <span className="hero__deco hero__deco--star2">★</span>
        </div>
      </div>

      <div className="hero__scroll" aria-hidden="true">
        <span className="hero__scroll-line" />
        <span className="hero__scroll-text">Scroll</span>
      </div>
    </section>
  )
}